import { useState } from "react";
import WhatsappWidgetSnippet from "./WAPopup/WASnippet";
import WidgetForm, { FormInputProps } from "@components/WAChatbutton/WAform/WidgetForm";
interface WhatsappWidgetGeneratorProps {
    widgetGeneratorRef: React.RefObject<HTMLDivElement>;
}
const WhatsappWidgetGenerator: React.FC<WhatsappWidgetGeneratorProps> = (props) => {
    const { widgetGeneratorRef } = props;
    const [popup, setpopup] = useState(false);
    const [formDetails, setFormDetails] = useState<FormInputProps>();
    const showSnippet = (details: FormInputProps) => {
        setFormDetails(details);
        setpopup(true);
    };

    const closeSnippet = () => {
        setpopup(false);
    };

    return (
        <div ref={widgetGeneratorRef}>
            <div className="pb-20">
                <WidgetForm onGenerate={showSnippet} />
            </div>
            {popup && formDetails && (
                <div
                    id="widget-popup"
                    className="lg:px-0 px-2 flex justify-center top-0 bottom-0 right-0 left-0 fixed z-10 w-screen overflow-y-scroll pb-14 pt-3 bg-black bg-opacity-50"
                    onClick={(e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
                        const modal = document.getElementById("widget-popup");
                        if (e.target === modal) {
                            closeSnippet();
                        }
                    }}
                >
                    <WhatsappWidgetSnippet data={formDetails} onClose={closeSnippet} />
                </div>
            )}
        </div>
    );
};
export default WhatsappWidgetGenerator;
